import React from "react";
import { Route, Routes } from "react-router";
import MainPage from "../page/MainPage";
import Login from "../page/LoginPage";
import About from "../page/AboutPage";
import Solution from "../page/Solution/SolutionPage";
import Notice from "../page/Notice/NoticePage";
import NoticeDetail from "../page/Notice/NoticeDetail";
import ContnetInput from "../page/Notice/ContentInputPage";
import PrivateRoute from "./PrivateRouter";
import Tech from "../page/TechPage";
import NotFound from "../page/NotFoundPage";
import Privacy from "../page/PrivacyPage";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getCategory } from '../features/notice/noticeSlice';
import { getOption } from '../features/setting/settingSlice';

const AppRouter = () => {
  const dispatch = useDispatch();

    useEffect(() => {
      dispatch(getOption());
      dispatch(getCategory());
    }, []);
    
    return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/about" element={<About />} />
      <Route path="/solution" element={<Solution />} />
      <Route path="/tech" element={<Tech />} />
      <Route path="/notice" element={<Notice />} />
      <Route path="/notice/:noticeId" element={<NoticeDetail />} />
      <Route path="/privacy" element={<Privacy />} />
      
      <Route path="/notice/content" element={<PrivateRoute permissionLevel="admin" />}>
        <Route path="" element={<ContnetInput />} />
        <Route path=":noticeId" element={<ContnetInput />} />
      </Route>

      <Route path="/notice/*" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
      <Route path="/404" element={<NotFound />} />
    </Routes>

    );
  };
  
  export default AppRouter;


  